import { Directive, ElementRef, Input } from "@angular/core";
import { NativeDesktopSupport } from "./native-desktop-support";

// Note this must not be used with style="{{interpolation}}"
// as template interpolation will remove any set nativeDesktopStyle

@Directive({
  selector: "[nativeDesktopStyle]",
  standalone: false,
})
export class NativeDesktopStyle {
  private element: ElementRef;

  constructor(element: ElementRef) {
    this.element = element;
  }

  @Input("nativeDesktopStyle")
  set value(value: any) {
    NativeDesktopSupport.initializationSubject.subscribe(
      (() => {
        if (value != null) {
          for (let key in value) {
            this.element.nativeElement["style"][key] = value[key];
          }
        }
      }).bind(this),
    );
  }
}
